import script from "./HrPageSticky.vue?vue&type=script&setup=true&lang=js"
export * from "./HrPageSticky.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky});
